export default {
	props:{
		id: String,
		name: String,
		currencyPrefix: {type:String, default: ''},
		currencySuffix: {type:String, default: ''},
		minValue: {type:[String, Number], default(){return null;}},
		maxValue: {type:[String, Number], default(){return null;}},
		minRange: {type:[String, Number], default:0},
		maxRange: {type:[String, Number], default:0},
		step: {type:[String, Number], default:1},
	},
	data(){
		return {
			innerMinValue: null,
			innerMaxValue: null,
		}
	},
	watch: {
		minValue:{
			immediate: true,
			handler(val){
				this.innerMinValue = val!=null ? val : this.minRange;
			},
		},
		maxValue:{
			immediate: true,
			handler(val){
				this.innerMaxValue = val!=null ? val : this.maxRange;
			},
		},
		innerMinValue:{
			handler(val){
				this.updateSliderProgress();
				this.$emit('update:minValue', val!=this.minRange?val:null);
				this.$emit('change');
			}
		},
		innerMaxValue:{
			handler(val){
				this.updateSliderProgress();
				this.$emit('update:maxValue', val!=this.maxRange?val:null);
				this.$emit('change');
			}
		}
	},
	computed:{
		flt_minRange(){ return parseFloat(this.minRange); },
		flt_maxRange(){ return parseFloat(this.maxRange); },
		flt_innerMinValue(){ return this.innerMinValue?parseFloat(this.innerMinValue):0; },
		flt_innerMaxValue(){ return this.innerMaxValue?parseFloat(this.innerMaxValue):0; },
		minMaxValue(){ return [this.innerMinValue,this.innerMaxValue].join(','); },
		minMaxRange(){ return [this.minRange,this.maxRange].join(','); },
		isMinMaxValueDifferentThanMinMaxRange(){ return this.minMaxValue!==this.minMaxRange; },
	},
	methods: {
		getPercent(value, min, max){
			let res = ((value - min) / (max - min)) * 100;
			if(res>100){ res = 100;}
			if(res<0){ res = 0;}
			return res;
		},
		updateSliderProgress(){
			if(this.$refs.slider){
				const left = this.getPercent(this.flt_innerMinValue, this.flt_minRange, this.flt_maxRange);
				const right = 100 - this.getPercent(this.flt_innerMaxValue, this.flt_minRange, this.flt_maxRange);
				this.$refs.slider.style.setProperty("--progressLeft", `${left.toFixed(2)}%`);
				this.$refs.slider.style.setProperty("--progressRight", `${right.toFixed(2)}%`);
			}
		},
		onChangeValue(ev, type){
			let val = parseFloat(ev.target.value)
			switch (type){
				case 'min':
					if(val>this.flt_innerMaxValue){
						ev.target.value = this.innerMaxValue;
					} else {
						this.innerMinValue = String(val);
					}
					break;
				case 'max':
					if(val<this.flt_innerMinValue){
						ev.target.value = this.innerMinValue;
					} else {
						this.innerMaxValue = String(val);
					}
				default:
					break;
			}
		},
	},
	mounted() {
		this.updateSliderProgress();
	},
	template: `
<div class="qit-input-minmax-range-slider" ref="slider">
	<div class="minmax-inputs">
		<span class="min-input">{{ currencyPrefix }}{{ innerMinValue }}{{ currencySuffix }}</span>
		<span class="max-input">{{ currencyPrefix }}{{ innerMaxValue }}{{ currencySuffix }}</span>
	</div>
  <div class="minmax-range-slider">
   	<div class="minmax-indicator"></div>
    <input
    	type="range" class="min-range-slider" 
    	:min="minRange" :max="maxRange" :step="step" :value="innerMinValue" @input="onChangeValue($event, 'min')"
    />
    <input 
    	type="range" class="max-range-slider" 
    	:min="minRange" :max="maxRange" :step="step" :value="innerMaxValue" @input="onChangeValue($event, 'max')"
    />
  </div>
	<input v-if="isMinMaxValueDifferentThanMinMaxRange" type="hidden" :name="name" :value="minMaxValue"/>
</div>
`,
}